module.exports = __webpack_public_path__ + "static/img/card_2_2.2cefe4d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pt/card_2_2.png
// module id = RsKR
// module chunks = 0